export default {
  name: "loading",
  data () {
    return {
      isShow: false,     // 是否显示loading
      isShowContent: false,
    }
  },
  methods: {
    show () {
      this.isShow = true;
      this.isShowContent = true;
    },
    hide () {
      this.isShowContent = false;
    }
  },
  watch: {
    "isShowContent": function () {
      // 等待fading效果结束再移除元素
      if(!this.isShowContent) {
        window.setTimeout( () => {
          this.isShow = false;
        }, 250);
      }
    }
  }
}